import {
    ChatMessageDtoReadState,
    ChatMessageDtoSide,
    FriendDtoState,
    DefaultTimezoneScope,
    UserNotificationState,
    IsTenantAvailableOutputState,
    IncomeStatisticsDateInterval,
    RegisterTenantInputSubscriptionStartType,
    CreatePaymentDtoEditionPaymentType,
    CreatePaymentDtoPaymentPeriodType,
    CreatePaymentDtoSubscriptionPaymentGatewayType,
    SalesSummaryDatePeriod,
    NoteEditDtoType,
    UserAddressDtoType,
    UserPhoneDtoType,
    CreateOrEditSituationDtoType,
    CreateEnterpriseInputType,
    UserMemberEditDtoCorrespondenceSituation,
    EventAddressDtoType,
    PayableDtoType,
    CreateOrEditReceivableDtoStatus,
    CouponResponsibleDtoType,
    MoneyPaymentMethodDtoEnvironmentType,
    RegistrationDtoSituation,
    DocumentationStatus,
    CreateOrEditCnabDtoStatus,
    CreateOrEditTopicDtoType,
    Status,
    CreateOrEditInvitationDtoStatus,
    InvitationActivityDtoApproved,
    CertificateConfigTextDtoCertificateType,
    CostCenterDtoFilterType,
    StatusCpf,
    UserMemberEditDtoGender,
    CreateOrEditWorkDtoType,
    AuthorDtoCategory,
    WorkDtoStatus,
    CreateOrEditInstitutionWorkDtoStatus,
    CreateOrEditWorkDtoSolicitedPresentationType,
    CreateOrEditInvitationWorkDtoStatus,
    CreateOrEditSurveyAnswerWorkDtoAnswerWork,
    AnnuityDtoStatusIntegracao,
    WorkApprovalDtoApproved,
} from "@shared/service-proxies/service-proxies";

export class AppChatMessageReadState {
    static Unread: number = ChatMessageDtoReadState._1;
    static Read: number = ChatMessageDtoReadState._2;
}

export class AppChatSide {
    static Sender: number = ChatMessageDtoSide._1;
    static Receiver: number = ChatMessageDtoSide._2;
}

export class AppFriendshipState {
    static Accepted: number = FriendDtoState._1;
    static Blocked: number = FriendDtoState._2;
}

export class AppTimezoneScope {
    static Application: number = DefaultTimezoneScope._1;
    static Tenant: number = DefaultTimezoneScope._2;
    static User: number = DefaultTimezoneScope._4;
}

export class AppUserNotificationState {
    static Unread: number = UserNotificationState._0;
    static Read: number = UserNotificationState._1;
}

export class AppTenantAvailabilityState {
    static Available: number = IsTenantAvailableOutputState._1;
    static InActive: number = IsTenantAvailableOutputState._2;
    static NotFound: number = IsTenantAvailableOutputState._3;
}

export class AppIncomeStatisticsDateInterval {
    static Daily: number = IncomeStatisticsDateInterval._1;
    static Weekly: number = IncomeStatisticsDateInterval._2;
    static Monthly: number = IncomeStatisticsDateInterval._3;
}

export class SubscriptionStartType {
    static Free: number = RegisterTenantInputSubscriptionStartType._1;
    static Trial: number = RegisterTenantInputSubscriptionStartType._2;
    static Paid: number = RegisterTenantInputSubscriptionStartType._3;
}

export class EditionPaymentType {
    static NewRegistration: number = CreatePaymentDtoEditionPaymentType._0;
    static BuyNow: number = CreatePaymentDtoEditionPaymentType._1;
    static Upgrade: number = CreatePaymentDtoEditionPaymentType._2;
    static Extend: number = CreatePaymentDtoEditionPaymentType._3;
}

export class AppEditionExpireAction {
    static DeactiveTenant = "DeactiveTenant";
    static AssignToAnotherEdition = "AssignToAnotherEdition";
}

export class PaymentPeriodType {
    static Monthly: number = CreatePaymentDtoPaymentPeriodType._30;
    static Annual: number = CreatePaymentDtoPaymentPeriodType._365;
}

export class SubscriptionPaymentGatewayType {
    static Paypal: number = CreatePaymentDtoSubscriptionPaymentGatewayType._1;
}

export class AppSalesSummaryDatePeriod {
    static Daily: number = SalesSummaryDatePeriod._1;
    static Weekly: number = SalesSummaryDatePeriod._2;
    static Monthly: number = SalesSummaryDatePeriod._3;
}

export class AppNoteEditDtoType {
    static Activate: number = NoteEditDtoType._0;
    static General: number = NoteEditDtoType._1;
    static Situation: number = NoteEditDtoType._2;
    static PaymentCharge: number = NoteEditDtoType._3;

    static Types: number[] = [
        AppNoteEditDtoType.Activate,
        AppNoteEditDtoType.General,
        AppNoteEditDtoType.Situation,
        AppNoteEditDtoType.PaymentCharge,
    ];

    static GetDescription(type: number): string {
        if (type == AppNoteEditDtoType.Activate) return "Activate";
        else if (type == AppNoteEditDtoType.General) return "General";
        else if (type == AppNoteEditDtoType.Situation) return "Situation";
        else if (type == AppNoteEditDtoType.PaymentCharge)
            return "Payment Charge";
    }
}

export class AppSituationType {
    static Member: number = CreateOrEditSituationDtoType._0;
    static Enterprise: number = CreateOrEditSituationDtoType._1;

    static Types: number[] = [
        AppSituationType.Member,
        AppSituationType.Enterprise,
    ];

    static GetDescription(type: number): string {
        if (type == AppSituationType.Member) return "Member";
        else return "Enterprise";
    }
}

export class AppCorrespondenceSituation {
    static Correspondence: number = UserMemberEditDtoCorrespondenceSituation._0;
    static Residence: number = UserMemberEditDtoCorrespondenceSituation._1;
    static UpdateAddress: number = UserMemberEditDtoCorrespondenceSituation._2;
    static Old: number = UserMemberEditDtoCorrespondenceSituation._3;
    static NotSendCorrespondence: number =
        UserMemberEditDtoCorrespondenceSituation._4;
    static Hospital: number = UserMemberEditDtoCorrespondenceSituation._5;
    static NoData: number = UserMemberEditDtoCorrespondenceSituation._6;

    static Types: number[] = [
        AppCorrespondenceSituation.Correspondence,
        AppCorrespondenceSituation.Residence,
        AppCorrespondenceSituation.UpdateAddress,
        AppCorrespondenceSituation.Old,
        AppCorrespondenceSituation.NotSendCorrespondence,
        AppCorrespondenceSituation.Hospital,
        AppCorrespondenceSituation.NoData,
    ];

    static GetDescription(type: number): string {
        if (type == AppCorrespondenceSituation.Correspondence)
            return "Correspondence";
        if (type == AppCorrespondenceSituation.Residence) return "Residence";
        if (type == AppCorrespondenceSituation.UpdateAddress)
            return "Update Address";
        if (type == AppCorrespondenceSituation.Old) return "Old";
        if (type == AppCorrespondenceSituation.NotSendCorrespondence)
            return "Not Send Correspondence";
        if (type == AppCorrespondenceSituation.Hospital) return "Hospital";
        if (type == AppCorrespondenceSituation.NoData) return "NoData";
    }
}

export class AppUserAddressDtoType {
    static Home: number = UserAddressDtoType._0;
    static Business: number = UserAddressDtoType._1;
}

export class AppPhoneType {
    static Mobile: number = UserPhoneDtoType._0;
    static Home: number = UserPhoneDtoType._1;
    static Business: number = UserPhoneDtoType._2;
    static Emergency: number = UserPhoneDtoType._3;
    static Fax: number = UserPhoneDtoType._4;

    static Types: number[] = [
        AppPhoneType.Mobile,
        AppPhoneType.Home,
        AppPhoneType.Business,
        AppPhoneType.Emergency,
        AppPhoneType.Fax,
    ];

    static GetDescription(type: number): string {
        if (type == AppPhoneType.Mobile) return "Mobile";
        else if (type == AppPhoneType.Home) return "Home";
        else if (type == AppPhoneType.Business) return "Business";
        else if (type == AppPhoneType.Emergency) return "Emergency";
        else return "Fax";
    }

    static GetType(type: number): number {
        if (type == AppPhoneType.Mobile) return AppPhoneType.Mobile;
        else if (type == AppPhoneType.Home) return AppPhoneType.Home;
        else if (type == AppPhoneType.Business) return AppPhoneType.Business;
        else if (type == AppPhoneType.Emergency) return AppPhoneType.Emergency;
        else return AppPhoneType.Fax;
    }
}

export class EnterpriseType {
    static CET: number = CreateEnterpriseInputType._0;
    static Distributor: number = CreateEnterpriseInputType._1;
    static Sponsor: number = CreateEnterpriseInputType._2;
    static MedicalResidency: number = CreateEnterpriseInputType._3;

    static Types: number[] = [
        EnterpriseType.CET,
        EnterpriseType.Distributor,
        EnterpriseType.Sponsor,
        EnterpriseType.MedicalResidency,
    ];

    static GetDescription(type: number): string {
        if (type == EnterpriseType.CET) return "CET";
        else if (type == EnterpriseType.Distributor) return "Distributor";
        else if (type == EnterpriseType.Sponsor) return "Sponsor";
        else return "Medical Residency";
    }
}

export class ProtocolType {
    static Entry: string = "EntryProtocol";
    static DropOff: string = "DropOffProtocol";

    static Types: string[] = [ProtocolType.Entry, ProtocolType.DropOff];

    static GetDescription(type: string): string {
        if (type == ProtocolType.Entry) return "Entry";
        else return "Drop Off";
    }
}

export class ActivityType {
    static BoardActivity: string = "BoardActivity";
    static CommissionActivity: string = "CommissionActivity";
    static CollaboratorActivity: string = "CollaboratorActivity";

    static Types: string[] = [
        ActivityType.BoardActivity,
        ActivityType.CommissionActivity,
        ActivityType.CollaboratorActivity,
    ];

    static GetDescription(type: string): string {
        if (type == ActivityType.BoardActivity) return "Board Activity";
        else if (type == ActivityType.CommissionActivity)
            return "Commission Activity";
        else return "Collaborator Activity";
    }
}

export class PaymentMethod {
    static Money: string = "MoneyPaymentMethod";
    static Ticket: string = "TicketPaymentMethod";
    static CreditCard: string = "CreditCardPaymentMethod";
    static DebitCard: string = "DebitCardPaymentMethod";
    static Check: string = "CheckPaymentMethod";
    static Deposit: string = "DepositPaymentMethod";
    static BankTransfer: string = "BankTransferPaymentMethod";
    static Coupon: string = "CouponPaymentMethod";

    static Types: string[] = [
        PaymentMethod.Money,
        PaymentMethod.Ticket,
        PaymentMethod.CreditCard,
        PaymentMethod.DebitCard,
        PaymentMethod.Check,
        PaymentMethod.Deposit,
        PaymentMethod.BankTransfer,
        PaymentMethod.Coupon,
    ];

    static GetDescription(type: string): string {
        switch (type) {
            case PaymentMethod.Money:
                return "Money";
            case PaymentMethod.Ticket:
                return "Ticket";
            case PaymentMethod.CreditCard:
                return "Credit Card";
            case PaymentMethod.DebitCard:
                return "Debit Card";
            case PaymentMethod.Check:
                return "Check";
            case PaymentMethod.Deposit:
                return "Deposit";
            case PaymentMethod.BankTransfer:
                return "Bank Transfer";
            case PaymentMethod.Coupon:
                return "Coupon";
        }
    }
}

export class PaymentType {
    static Payment: string = "Payment";
    static DebitCard: string = "DebitCardPayment";
    static CreditCard: string = "CreditCardPayment";

    static Types: string[] = [
        PaymentType.Payment,
        PaymentType.DebitCard,
        PaymentType.CreditCard,
    ];

    static GetDescription(type: string): string {
        switch (type) {
            case PaymentType.Payment:
                return "Payment";
            case PaymentType.DebitCard:
                return "Debit Card";
            case PaymentType.CreditCard:
                return "Credit Card";
        }
    }
}

export class PaymentCardType {
    static Debit: string = "Debit";
    static Credit: string = "Credit";

    static Types: string[] = [PaymentCardType.Debit, PaymentCardType.Credit];

    static GetDescription(type: string): string {
        switch (type) {
            case PaymentCardType.Debit:
                return "Debit Card";
            case PaymentCardType.Credit:
                return "Credit Card";
        }
    }
}

export class EventAddressType {
    static Home: number = EventAddressDtoType._0;
    static Business: number = EventAddressDtoType._1;

    static Types: number[] = [EventAddressType.Home, EventAddressType.Business];

    static GetDescription(type: number): string {
        switch (type) {
            case EventAddressType.Home:
                return "Home";
            case EventAddressType.Business:
                return "Business";

            default:
                return "Invalid choice";
        }
    }
}

export class PayableType {
    static Ticket: number = PayableDtoType._0;
    static Check: number = PayableDtoType._1;
    static Devolution: number = PayableDtoType._2;
    static Invoice: number = PayableDtoType._3;
    static NF: number = PayableDtoType._4;
    static BankTransfer: number = PayableDtoType._5;
    static AccountDebit: number = PayableDtoType._6;
    static Others: number = PayableDtoType._7;

    static Types: number[] = [
        PayableType.Ticket,
        PayableType.Check,
        PayableType.Devolution,
        PayableType.Invoice,
        PayableType.NF,
        PayableType.BankTransfer,
        PayableType.AccountDebit,
        PayableType.Others,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case PayableType.Ticket:
                return "Ticket";
            case PayableType.Check:
                return "Check";
            case PayableType.Devolution:
                return "Devolution";
            case PayableType.Invoice:
                return "Invoice";
            case PayableType.NF:
                return "NF";
            case PayableType.BankTransfer:
                return "Bank Transfer";
            case PayableType.AccountDebit:
                return "Account Debit";
            case PayableType.Others:
                return "Others";
        }
    }
}

export class PaymentChargeStatus {
    static WaitingForPayment: number = CreateOrEditReceivableDtoStatus._0;
    static Finished: number = CreateOrEditReceivableDtoStatus._1;
    static Canceled: number = CreateOrEditReceivableDtoStatus._2;

    static Types: number[] = [
        PaymentChargeStatus.WaitingForPayment,
        PaymentChargeStatus.Finished,
        PaymentChargeStatus.Canceled,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case PaymentChargeStatus.WaitingForPayment:
                return "Waiting For Payment";
            case PaymentChargeStatus.Finished:
                return "Finished";
            case PaymentChargeStatus.Canceled:
                return "Canceled";
        }
    }
}

export class StatusIntegracao {
    static Waiting: number = AnnuityDtoStatusIntegracao._0;
    static Success: number = AnnuityDtoStatusIntegracao._1;
    static Fail: number = AnnuityDtoStatusIntegracao._2;

    static Types: number[] = [
        StatusIntegracao.Waiting,
        StatusIntegracao.Success,
        StatusIntegracao.Fail,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case StatusIntegracao.Waiting:
                return "Waiting";
            case StatusIntegracao.Success:
                return "Success";
            case StatusIntegracao.Fail:
                return "Fail";
        }
    }
}

export class FilterType {
    static All: number = CostCenterDtoFilterType._0;
    static Receivable: number = CostCenterDtoFilterType._1;
    static Payable: number = CostCenterDtoFilterType._2;

    static Types: number[] = [
        FilterType.All,
        FilterType.Receivable,
        FilterType.Payable,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case FilterType.All:
                return "All";
            case FilterType.Receivable:
                return "Receivable";
            case FilterType.Payable:
                return "Payable";
        }
    }
}

export class DocumentationStatusMember {
    static WaitingForApproval: number = DocumentationStatus._0;
    static Approved: number = DocumentationStatus._1;
    static Disapproved: number = DocumentationStatus._2;
    static NotSent: number = DocumentationStatus._3;

    static Types: number[] = [
        DocumentationStatusMember.WaitingForApproval,
        DocumentationStatusMember.Approved,
        DocumentationStatusMember.Disapproved,
        DocumentationStatusMember.NotSent,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case DocumentationStatusMember.WaitingForApproval:
                return "Waiting For Approval";
            case DocumentationStatusMember.Approved:
                return "Approved";
            case DocumentationStatusMember.Disapproved:
                return "Disapproved";
            case DocumentationStatusMember.NotSent:
                return "Not Sent";
        }
    }
}

export class ResponsibleType {
    static Enterprise: number = CouponResponsibleDtoType._0;
    static User: number = CouponResponsibleDtoType._1;

    static Types: number[] = [ResponsibleType.Enterprise, ResponsibleType.User];

    static GetDescription(type: number): string {
        switch (type) {
            case ResponsibleType.Enterprise:
                return "Enterprise";
            case ResponsibleType.User:
                return "User";
        }
    }
}

export class ReceivableType {
    static Receivable: string = "Receivable";
    static Annuity: string = "MemberAnnuity";
    static Registration: string = "Registration";
    static Order: string = "Order";

    static Types: string[] = [
        ReceivableType.Receivable,
        ReceivableType.Annuity,
        ReceivableType.Registration,
        ReceivableType.Order,
    ];

    static GetDescription(type: string): string {
        switch (type) {
            case ReceivableType.Receivable:
                return "Receivable";
            case ReceivableType.Annuity:
                return "Annuity";
            case ReceivableType.Registration:
                return "Registration";
            case ReceivableType.Order:
                return "Order";
        }
    }
}

export class PaymentEnvironmentType {
    static Homolog: number = MoneyPaymentMethodDtoEnvironmentType._0;
    static Production: number = MoneyPaymentMethodDtoEnvironmentType._1;
    static Test: number = MoneyPaymentMethodDtoEnvironmentType._2;

    static Types: number[] = [
        PaymentEnvironmentType.Homolog,
        PaymentEnvironmentType.Production,
        PaymentEnvironmentType.Test,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case PaymentEnvironmentType.Homolog:
                return "Homolog";
            case PaymentEnvironmentType.Production:
                return "Production";
            case PaymentEnvironmentType.Test:
                return "Test";
        }
    }
}

export class SubscriptionSituationType {
    static Approved: number = RegistrationDtoSituation._0;
    static WaitingForApproval: number = RegistrationDtoSituation._1;
    static WaitingForNextEvent: number = RegistrationDtoSituation._2;
    static CancelledByRequest: number = RegistrationDtoSituation._3;
    static CancelledByPaymentPending: number = RegistrationDtoSituation._4;
    static CancelledByDivergence: number = RegistrationDtoSituation._5;
    static Disapproved: number = RegistrationDtoSituation._6;
    static TransferredToEvent: number = RegistrationDtoSituation._7;
    static TransferredToUser: number = RegistrationDtoSituation._8;
    static CancelledByDuplicate: number = RegistrationDtoSituation._9;

    static Types: number[] = [
        SubscriptionSituationType.Approved,
        SubscriptionSituationType.WaitingForApproval,
        SubscriptionSituationType.WaitingForNextEvent,
        SubscriptionSituationType.CancelledByRequest,
        SubscriptionSituationType.CancelledByPaymentPending,
        SubscriptionSituationType.CancelledByDivergence,
        SubscriptionSituationType.Disapproved,
        SubscriptionSituationType.TransferredToEvent,
        SubscriptionSituationType.TransferredToUser,
        SubscriptionSituationType.CancelledByDuplicate,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case SubscriptionSituationType.Approved:
                return "Approved";
            case SubscriptionSituationType.WaitingForApproval:
                return "Waiting For Approval";
            case SubscriptionSituationType.WaitingForNextEvent:
                return "Waiting For Next Event";
            case SubscriptionSituationType.CancelledByRequest:
                return "Cancelled By Request";
            case SubscriptionSituationType.CancelledByPaymentPending:
                return "Cancelled By Payment Pending";
            case SubscriptionSituationType.CancelledByDivergence:
                return "Cancelled By Divergence";
            case SubscriptionSituationType.Disapproved:
                return "Disapproved";
            case SubscriptionSituationType.TransferredToEvent:
                return "Transferred To Another Event";
            case SubscriptionSituationType.TransferredToUser:
                return "Transferred To Another User";
            case SubscriptionSituationType.CancelledByDuplicate:
                return "Cancelled By Duplicate";
        }
    }
}

export class PaymentChargeType {
    static Receivable: string = "Receivable";
    static Payable: string = "Payable";

    static Types: string[] = [
        PaymentChargeType.Receivable,
        PaymentChargeType.Payable,
    ];

    static GetDescription(type: string): string {
        switch (type) {
            case PaymentChargeType.Receivable:
                return "Receivable";
            case PaymentChargeType.Payable:
                return "Payable";
        }
    }
}

export class CnabStatus {
    static Waiting: number = CreateOrEditCnabDtoStatus._0;
    static Processing: number = CreateOrEditCnabDtoStatus._1;
    static Finished: number = CreateOrEditCnabDtoStatus._2;

    static Types: number[] = [
        CnabStatus.Waiting,
        CnabStatus.Processing,
        CnabStatus.Finished,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case CnabStatus.Waiting:
                return "Waiting";
            case CnabStatus.Processing:
                return "Processing";
            case CnabStatus.Finished:
                return "Finished";
        }
    }
}

export class TopicType {
    static MainTopic: number = CreateOrEditTopicDtoType._0;
    static SubTopic: number = CreateOrEditTopicDtoType._1;
    static Lunch: number = CreateOrEditTopicDtoType._2;
    static CoffeeBreak: number = CreateOrEditTopicDtoType._3;
    static Interval: number = CreateOrEditTopicDtoType._4;

    static Types: number[] = [
        TopicType.MainTopic,
        TopicType.SubTopic,
        TopicType.Lunch,
        TopicType.CoffeeBreak,
        TopicType.Interval,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case TopicType.MainTopic:
                return "Topic";
            case TopicType.SubTopic:
                return "Subtopic";
            case TopicType.Lunch:
                return "Lunch";
            case TopicType.CoffeeBreak:
                return "Coffee Break";
            case TopicType.Interval:
                return "Interval";
        }
    }
}

export class ActivityStatus {
    static Pending: number = Status._0;
    static Finished: number = Status._1;

    static Types: number[] = [ActivityStatus.Pending, ActivityStatus.Finished];

    static GetDescription(type: number): string {
        switch (type) {
            case ActivityStatus.Pending:
                return "Pending";
            case ActivityStatus.Finished:
                return "Finished";
        }
    }
}

export class ActivityTemplateType {
    static Default: number = 0;
    static Custom: number = 1;

    static Types: number[] = [
        ActivityTemplateType.Default,
        ActivityTemplateType.Custom,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case ActivityTemplateType.Default:
                return "Default";
            case ActivityTemplateType.Custom:
                return "Custom";
        }
    }
}

export class InvitationStatus {
    static Created: number = CreateOrEditInvitationDtoStatus._0;
    static Sent: number = CreateOrEditInvitationDtoStatus._1;
    static Answered: number = CreateOrEditInvitationDtoStatus._2;
    static Canceled: number = CreateOrEditInvitationDtoStatus._3;
    static ChargeSent: number = CreateOrEditInvitationDtoStatus._4;

    static Types: number[] = [
        InvitationStatus.Created,
        InvitationStatus.Sent,
        InvitationStatus.Answered,
        InvitationStatus.Canceled,
        InvitationStatus.ChargeSent,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case InvitationStatus.Created:
                return "Created";
            case InvitationStatus.Sent:
                return "Sent";
            case InvitationStatus.Answered:
                return "Answered";
            case InvitationStatus.Canceled:
                return "Canceled";
            case InvitationStatus.ChargeSent:
                return "Charge Sent";
        }
    }
}

export class InvitationAnswerType {
    static Yes: number = InvitationActivityDtoApproved._0;
    static No: number = InvitationActivityDtoApproved._1;

    static Types: number[] = [
        InvitationAnswerType.Yes,
        InvitationAnswerType.No,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case InvitationAnswerType.Yes:
                return "Yes";
            case InvitationAnswerType.No:
                return "No";
        }
    }
}

export class CertificateType {
    static Appraiser: number = CertificateConfigTextDtoCertificateType._0;
    static Author: number = CertificateConfigTextDtoCertificateType._1;
    static Congressman: number = CertificateConfigTextDtoCertificateType._2;
    static Instructor: number = CertificateConfigTextDtoCertificateType._3;
    static Speaker: number = CertificateConfigTextDtoCertificateType._4;
    static Participant: number = CertificateConfigTextDtoCertificateType._5;
    static AuthorWork: number = CertificateConfigTextDtoCertificateType._8;

    static Types: number[] = [
        CertificateType.Appraiser,
        CertificateType.Author,
        CertificateType.Congressman,
        CertificateType.Instructor,
        CertificateType.Speaker,
        CertificateType.Participant,
        CertificateType.AuthorWork,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case CertificateType.Appraiser:
                return "Appraiser";
            case CertificateType.Author:
                return "Author";
            case CertificateType.Congressman:
                return "Congressman";
            case CertificateType.Instructor:
                return "Instructor";
            case CertificateType.Speaker:
                return "Speaker";
            case CertificateType.Participant:
                return "Participant";
            case CertificateType.AuthorWork:
                return "AuthorWork";
        }
    }
}

export class QuestionType {
    static MultipleChoice: number = 0;
    static BoxSelection: number = 1;
    static StarRating: number = 2;
    static Comment: number = 3;
    static ContactInformation: number = 4;
    static Group: number = 5;
    static Text: number = 6;

    static Types: number[] = [
        QuestionType.MultipleChoice,
        QuestionType.BoxSelection,
        QuestionType.StarRating,
        QuestionType.Comment,
        QuestionType.ContactInformation,
        QuestionType.Group,
        QuestionType.Text,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case QuestionType.MultipleChoice:
                return "Multiple Choice";
            case QuestionType.BoxSelection:
                return "Box Selection";
            case QuestionType.StarRating:
                return "Star Rating";
            case QuestionType.Comment:
                return "Comment";
            case QuestionType.ContactInformation:
                return "Contact Information";
            case QuestionType.Group:
                return "Group";
            case QuestionType.Text:
                return "Text";
        }
    }
}

export class SurveyCategory {
    static Event: number = 0;
    static Satisfaction: number = 1;
    static Feedback: number = 2;

    static Types: number[] = [
        SurveyCategory.Event,
        SurveyCategory.Satisfaction,
        SurveyCategory.Feedback,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case SurveyCategory.Event:
                return "Event";
            case SurveyCategory.Satisfaction:
                return "Satisfaction";
            case SurveyCategory.Feedback:
                return "Feedback";
        }
    }
}

export class SurveyWorkCategory {
    static Work: number = 0;
    static Presentation: number = 1;

    static Types: number[] = [
        SurveyWorkCategory.Work,
        SurveyWorkCategory.Presentation,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case SurveyWorkCategory.Work:
                return "Work";
            case SurveyWorkCategory.Presentation:
                return "Presentation";
        }
    }
}

export class StatusCPF {
    static Invalido: number = StatusCpf._0;
    static Valido: number = StatusCpf._1;
    static AguardandoValidacao: number = StatusCpf._2;

    static Types: number[] = [
        StatusCPF.Invalido,
        StatusCPF.Valido,
        StatusCPF.AguardandoValidacao,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case StatusCPF.Invalido:
                return "Inválido";
            case StatusCPF.Valido:
                return "Válido";
            case StatusCPF.AguardandoValidacao:
                return "Aguardando Validação";
        }
    }
}

export class MemberGender {
    static Female: number = UserMemberEditDtoGender._0;
    static Male: number = UserMemberEditDtoGender._1;

    static Types: number[] = [MemberGender.Female, MemberGender.Male];

    static GetDescription(type: number): string {
        switch (type) {
            case MemberGender.Female:
                return "Feminino";
            case MemberGender.Male:
                return "Masculino";
        }
    }
}

export class WorkType {
    static ScientificArticle: number = CreateOrEditWorkDtoType._0;
    static CaseReport: number = CreateOrEditWorkDtoType._1;

    static Types: number[] = [WorkType.ScientificArticle, WorkType.CaseReport];

    static GetDescription(type: number): string {
        switch (type) {
            case WorkType.ScientificArticle:
                return "ScientificArticle";
            case WorkType.CaseReport:
                return "CaseReport";
        }
    }
}

export class InstitutionWorkStatus {
    static Pending: number = CreateOrEditInstitutionWorkDtoStatus._0;
    static Finished: number = CreateOrEditInstitutionWorkDtoStatus._1;
    static Disabled: number = CreateOrEditInstitutionWorkDtoStatus._2;

    static Types: number[] = [
        InstitutionWorkStatus.Pending,
        InstitutionWorkStatus.Finished,
        InstitutionWorkStatus.Disabled,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case InstitutionWorkStatus.Pending:
                return "Pending";
            case InstitutionWorkStatus.Finished:
                return "Finished";
            case InstitutionWorkStatus.Disabled:
                return "Disabled";
        }
    }
}

export class AuthorCategory {
    static MedicalSpecialist: number = AuthorDtoCategory._0;
    static GraduateDegree: number = AuthorDtoCategory._1;
    static SpecializingResident: number = AuthorDtoCategory._2;
    static Academic: number = AuthorDtoCategory._3;
    static HealthProfessional: number = AuthorDtoCategory._4;

    static Types: number[] = [
        AuthorCategory.MedicalSpecialist,
        AuthorCategory.GraduateDegree,
        AuthorCategory.SpecializingResident,
        AuthorCategory.Academic,
        AuthorCategory.HealthProfessional,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case AuthorCategory.MedicalSpecialist:
                return "MedicalSpecialist";
            case AuthorCategory.GraduateDegree:
                return "GraduateDegree";
            case AuthorCategory.SpecializingResident:
                return "SpecializingResident";
            case AuthorCategory.Academic:
                return "Academic";
            case AuthorCategory.HealthProfessional:
                return "HealthProfessional";
        }
    }
}

export class WorkStatus {
    static Created: number = WorkDtoStatus._0;
    static Sent: number = WorkDtoStatus._1;
    static InRevision: number = WorkDtoStatus._2;
    static ApprovedEPoster: number = WorkDtoStatus._3;
    static ApprovedPresentation: number = WorkDtoStatus._4;
    static Disapproved: number = WorkDtoStatus._5;
    static Deleted: number = WorkDtoStatus._6;
    static NotPresented: number = WorkDtoStatus._7;

    static Types: number[] = [
        WorkStatus.Created,
        WorkStatus.Sent,
        WorkStatus.InRevision,
        WorkStatus.ApprovedEPoster,
        WorkStatus.ApprovedPresentation,
        WorkStatus.Disapproved,
        WorkStatus.Deleted,
        WorkStatus.NotPresented,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case WorkStatus.Created:
                return "Created";
            case WorkStatus.Sent:
                return "Sent";
            case WorkStatus.InRevision:
                return "InRevision";
            case WorkStatus.ApprovedEPoster:
                return "ApprovedEPoster";
            case WorkStatus.ApprovedPresentation:
                return "ApprovedPresentation";
            case WorkStatus.Disapproved:
                return "Disapproved";
            case WorkStatus.Deleted:
                return "Deleted";
            case WorkStatus.NotPresented:
                return "NotPresented";
        }
    }
}

export class SolicitedPresentationType {
    static EPoster: number = CreateOrEditWorkDtoSolicitedPresentationType._0;
    // static Presentation: number =
    //     CreateOrEditWorkDtoSolicitedPresentationType._1;

    static Types: number[] = [
        SolicitedPresentationType.EPoster,
        // SolicitedPresentationType.Presentation,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case SolicitedPresentationType.EPoster:
                return "EPoster";
            // case SolicitedPresentationType.Presentation:
            //     return "Presentation";
        }
    }
}

export class InvitationWorkStatus {
    static Created: number = CreateOrEditInvitationWorkDtoStatus._0;
    static Sent: number = CreateOrEditInvitationWorkDtoStatus._1;
    static Answered: number = CreateOrEditInvitationWorkDtoStatus._2;
    static Canceled: number = CreateOrEditInvitationWorkDtoStatus._3;

    static Types: number[] = [
        InvitationWorkStatus.Created,
        InvitationWorkStatus.Sent,
        InvitationWorkStatus.Answered,
        InvitationWorkStatus.Canceled,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case InvitationWorkStatus.Created:
                return "Created";
            case InvitationWorkStatus.Sent:
                return "Sent";
            case InvitationWorkStatus.Answered:
                return "Answered";
            case InvitationWorkStatus.Canceled:
                return "Canceled";
        }
    }
}

export class QuestionWorkType {
    static StarRating: number = 0;

    static Types: number[] = [QuestionWorkType.StarRating];

    static GetDescription(type: number): string {
        switch (type) {
            case QuestionWorkType.StarRating:
                return "Star Rating";
        }
    }
}

export class SurveyAnswer {
    static InRevision: number = CreateOrEditSurveyAnswerWorkDtoAnswerWork._0;
    static ApprovedEPoster: number =
        CreateOrEditSurveyAnswerWorkDtoAnswerWork._1;
    static ApprovedPresentation: number =
        CreateOrEditSurveyAnswerWorkDtoAnswerWork._2;
    static Disapproved: number = CreateOrEditSurveyAnswerWorkDtoAnswerWork._3;

    static Types: number[] = [
        SurveyAnswer.InRevision,
        SurveyAnswer.ApprovedEPoster,
        SurveyAnswer.ApprovedPresentation,
        SurveyAnswer.Disapproved,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case SurveyAnswer.InRevision:
                return "InRevision";
            case SurveyAnswer.ApprovedEPoster:
                return "ApprovedEPoster";
            case SurveyAnswer.ApprovedPresentation:
                return "ApprovedPresentation";
            case SurveyAnswer.Disapproved:
                return "Disapproved";
        }
    }
}

export class ApprovalAnswer {
    static Yes: number = WorkApprovalDtoApproved._0;
    static No: number = WorkApprovalDtoApproved._1;
    static NotApplicable: number = WorkApprovalDtoApproved._2;

    static Types: number[] = [
        ApprovalAnswer.Yes,
        ApprovalAnswer.No,
        ApprovalAnswer.NotApplicable,
    ];

    static GetDescription(type: number): string {
        switch (type) {
            case ApprovalAnswer.Yes:
                return "Yes";
            case ApprovalAnswer.No:
                return "No";
            case ApprovalAnswer.NotApplicable:
                return "Not Applicable";
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/AppEnums.ts